var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"safe-html",rawName:"v-safe-html:[$options.safeHtmlConfig]",value:(_vm.data),expression:"data",arg:_vm.$options.safeHtmlConfig}]})
}
var staticRenderFns = []

export { render, staticRenderFns }